module.exports = __webpack_public_path__ + "img/csv_icon.74d0217e.svg";